<form class="needs-validation" [class.was-validated]="wasValidated" [formGroup]="form" *ngIf="form">
    <div class="row">
        <div class="col-12">
            <div class="card card-body mt-2">
                <form-customer [formControl]="form.get('customer')" [mobileText]="false" [admin]="admin"></form-customer>

                <div class="form-group row">
                    <label class="col-form-label col-md-4">{{ language.moveInfo.questions.label }}</label>
                    <div class="col-md-8">
                        <textarea
                            [formControl]="form.get('comment')"
                            class="form-control"
                            placeholder="{{ language.moveInfo.questions.label }}"
                            rows="10"
                            input-validation
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="my-3">
        <!-- Send button -->
        <div class="text-center">
            <button class="btn btn-success btn-lg ms-5" data-cy="submit" (click)="submitClick()">
                <fa-icon *ngIf="!loading.submit" [icon]="['fal', 'check']" [fixedWidth]="true"></fa-icon>
                <fa-icon *ngIf="loading.submit" [icon]="['fal', 'spinner-third']" [fixedWidth]="true" [spin]="true"></fa-icon>
                {{ language.submit.contact.buttonText }}
            </button>
        </div>

        <!-- Error -->
        <div class="alert alert-danger" *ngIf="serverError">
            <h5 class="alert-heading">{{ language.calculate.serverError.title }}</h5>
            <p class="mb-0" [innerHTML]="language.calculate.serverError.message"></p>
        </div>
    </div>
</form>

<re-captcha
    *ngIf="captchaActive"
    class="invisible"
    #captchaRef="reCaptcha"
    name="captcha"
    siteKey="6LfqzSkUAAAAAO_WvXKc6ovP_xiDcUtVmtjcmz-O"
    size="invisible"
    badge="inline"
    (resolved)="$event && submit($event)"
></re-captcha>
